import { convertAmountToUnit } from './mass-units.js';
const LIMIT_KEYS = ['minSingleDose', 'maxSingleDose', 'maxPerDay', 'maxPerCycle', 'maxLifetime'];
const VALUE_KEYS = ['absolute', 'bsa', 'auc', 'weight'];
/**
 * Converts the dose limits of a substance to its new dose unit (CY-369). Limits are stored without a unit,
 * so they must move with it; every value is an amount of the dose unit (per m², kg or AUC), so all scale alike.
 * A switch that can't be converted (to or from IU) is refused while any limit is set.
 */
export function convertDoseLimits(limits, from, to) {
    // the form stores an empty cell as 0, so only a non-zero value is a limit
    const hasValue = LIMIT_KEYS.some(limit => VALUE_KEYS.some(value => {
        const amount = limits[limit]?.[value];
        return amount != null && amount !== 0;
    }));
    if (!hasValue || from === to)
        return { ok: true, limits };
    const converted = {};
    try {
        for (const limit of LIMIT_KEYS) {
            const values = limits[limit];
            if (!values)
                continue;
            const next = {};
            for (const value of VALUE_KEYS) {
                const amount = values[value];
                if (amount == null)
                    continue;
                next[value] = convertAmountToUnit({ amount, from, to }).toDecimalPlaces(6).toNumber();
            }
            converted[limit] = next;
        }
    }
    catch {
        return { ok: false };
    }
    return { ok: true, limits: converted };
}
//# sourceMappingURL=dose-limits.js.map